import Template from '../../../../public/themes/smr/View/modules/module-references/references.twig';

export default {
  refWrapper: null,
  refInner: null,
  lastTile: null,
  loadMoreBtn: null,
  init(moduleEl) {
    this.refWrapper = moduleEl.querySelector('.references');
    this.refInner = moduleEl.querySelector('.references-inner');
    this.lastTile = this.refInner.querySelector('figure.lt') ?? null;
    this.loadMoreBtn = moduleEl.querySelector('figure.lm');

    window.smr_eventbus.on('load_references', () => {
      this.prepareWrapperHeight();
      this.refWrapper.classList.add('loading');
    });

    window.smr_eventbus.on('data loaded: replace_references', (data) => {
      this.replaceReferenceTiles(data);
    });

    window.smr_eventbus.on('data loaded: append_references', (data) => {
      this.appendReferenceTiles(data);
    });
  },
  replaceReferenceTiles(data) {
    this.prepareWrapperHeight(); // set height to enable smooth transition
    if (this.lastTile) this.lastTile.children[0].classList.add('hidden'); // hide last tile
    this.refInner.innerHTML = '';
    this.refInner.innerHTML = Template({
      references: data.data,
      ajax: true,
      has_more_pages: data.meta.current_page < data.meta.last_page,
    });
    if (this.lastTile) this.refInner.appendChild(this.lastTile); // readd last tile
    this.refInner.appendChild(this.loadMoreBtn); // readd load more button
    window.smr_eventbus.emit('reinit_ref_tiles');

    this.setNewWrapperHeight(); // animate to new height

    setTimeout(() => {
      this.refWrapper.classList.remove('loading');
      this.showHiddenElements();
    }, 5);
  },
  appendReferenceTiles(data) {
    this.prepareWrapperHeight(); // set height to enable smooth transition
    let firstNewTileIndex = null; // child index of first new tile to scroll to

    const maybeNotDisplayedTile =
      this.refInner.querySelector('div.refcol.d-none'); // on desktop 9th tile is hidden so fake text tile (last tile) is displayed instead

    if (maybeNotDisplayedTile) {
      // if 9th tile is hidden, save its index as first new tile index
      maybeNotDisplayedTile.classList.add('hidden');
      maybeNotDisplayedTile.classList.remove('d-none');
      firstNewTileIndex = Array.from(this.refInner.children).indexOf(
        maybeNotDisplayedTile
      );
    }

    this.refInner.removeChild(this.loadMoreBtn);
    if (this.lastTile) this.refInner.removeChild(this.lastTile);
    const html = Template({
      references: data.data,
      ajax: true,
      has_more_pages: data.meta.current_page < data.meta.last_page,
    });
    if (this.lastTile) this.lastTile.children[0].classList.add('hidden');

    if (!firstNewTileIndex) {
      // if first new tile index is not set, set it to the currently displayed number of tiles
      firstNewTileIndex = this.refInner.querySelectorAll('.refcol').length;
    }

    this.refInner.innerHTML += html; // append new tiles
    if (this.lastTile) this.refInner.appendChild(this.lastTile); // readd last tile
    this.refInner.appendChild(this.loadMoreBtn); // readd load more button
    this.setNewWrapperHeight(); // animate to new height

    setTimeout(() => {
      this.showHiddenElements();
      window.smr_eventbus.emit('reinit_ref_tiles'); // reinit reference tiles to enable text exposure on hover
      // get scroll position of first new tile and scroll to it
      const top =
        this.refInner.children[firstNewTileIndex].getBoundingClientRect().top +
        window.scrollY -
        100;
      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }, 5);
  },
  prepareWrapperHeight() {
    this.refWrapper.style.height = `${this.refInner.offsetHeight}px`;
  },
  setNewWrapperHeight() {
    this.refWrapper.style.height = `${this.refInner.offsetHeight}px`;

    setTimeout(() => {
      this.refWrapper.style.height = ''; // remove height after transition to enable auto height
    }, 300);
  },
  showHiddenElements() {
    // fades in hidden elements one by one
    let modifier = 1;
    const hiddenEls = this.refInner.querySelectorAll('.hidden');
    hiddenEls.forEach((el, index) => {
      if (el.classList.contains('d-none')) {
        // skip invisible elements
        modifier -= 1; // reduce modifier to keep correct fade in delay
        return;
      }
      setTimeout(() => {
        el.classList.remove('hidden');
      }, 100 * (index + modifier));
    });
  },
};
